<template>
  <div class="row" v-show="!messageSuccess">
    <div class="col-7 col-sm-7">
      <input
        v-model="form.email"
        type="email"
        class="form-control"
        :placeholder="lang == 'es' ? 'Correo Electrónico' : 'Email'"
      />
    </div>
    <button class="btn button-sucribtion col-5 col-sm-5 mx-auto" @click="store()" :disabled="loading">
      <i v-show="loading" class="fal fa-circle-notch fa-spin me-1"></i>
      <span> {{ lang == 'es' ? 'Suscribir' : 'Subscribe' }}</span>
    </button>
  </div>
  <span class="text-success">{{ messageSuccess }}</span>
  <div v-show="!messageSuccess">
    <span class="text-danger" v-for="(item, index) in errors" :key="index">{{ item[0] }}</span>
    <span class="text-danger" v-show="generalError">{{ generalError }}</span>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionRegister',
  props: {
    lang: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        email: '',
      },
      loading: false,
      errors: {},
      generalError: '',
      messageSuccess: '',
    }
  },
  methods: {
    store() {
      const self = this
      self.loading = true
      self.errors = {}
      self.generalError = ''
      axios
        .post('/subscriptions', {
          lang: self.lang,
          email: self.form.email,
        })
        .then((res) => {
          if (res.data.success) {
            self.messageSuccess = res.data.message
          }
        })
        .catch((e) => {
          const isEs = self.lang === 'es'
          if (e.response && e.response.status === 422 && e.response.data && e.response.data.errors) {
            self.errors = e.response.data.errors
          } else if (e.response && e.response.status === 429) {
            self.generalError = isEs
              ? 'Demasiados intentos. Espera un momento e inténtalo de nuevo.'
              : 'Too many attempts. Please wait a moment and try again.'
          } else {
            self.generalError = isEs
              ? 'No pudimos completar la suscripción. Revisa tu conexión e inténtalo de nuevo.'
              : 'We could not complete your subscription. Check your connection and try again.'
          }
        })
        .finally(() => {
          self.loading = false
        })
    },
  },
}
</script>
